const ResourceTypes = Object.freeze({
  URL: 'URLResource',
  SOURCE: 'SourceResource',
  LTI: 'LTIResource',
  ASSESSMENT: 'AssessmentResource',
  QUESTION_BANK: 'QuestionBankResource',
  QUESTION_BANK_BI: 'QuestionBankBIResource',
  TEACHER_MODULE: 'TeacherModuleResource',
  PRACTICE_QUESTIONS: 'PracticeQuestionsResource',
  YOUTUBE: 'YoutubeResource',
  PARTNER_LINK: 'PartnerLinkResource',
  DISTANCE_LINK: 'DistanceLinkResource',
  GROUP: 'GroupResource',
  PERFORMANCE_TASK: 'PerformanceTaskResource',
  EMBEDDED_VIDEO: 'EmbeddedVideoResource',
  EBOOK: 'EBookResource',
  SPP: 'StudentPracticeResource',
  // FY-23754 PE custom assessment
  ASSESSMENT_PE: 'PEAssessmentResource',
});

export const SubunitAssessmentTypes = Object.freeze({
  PPC: 'PPC',
  SPP: 'SPP',
  PE: 'PE',
  LC: 'LC',
  PT: 'PT',
});

export const ResourceContentTypes = Object.freeze({
  PDF: 'PDF',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  PROFESSIONAL_LINK: 'PROFESSIONAL_LINK',
});

/**
 * Todo: to be moved to UI-FYM
 * */
export const QuestionTypes = {
  FREE_RESPONSE_QUESTION: 'FreeResponseQuestion',
  MULTIPLE_CHOICE_QUESTION: 'MultipleChoiceQuestion',
};

export default ResourceTypes;
